import { Checkbox, DateRange, MomentObj, Search, SelectOption, TableColumns, TableColumnWidth, TableData } from '@veneer/core'
import React, { useCallback, useEffect, useState } from 'react'
import activationsService from '../../../services/agendaApi/activations.service';
import { IGetAssignmentOfActivationDto } from '../../../models/dto/agendaApi/IGetAssignmentOfActivationDto';
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import { FormatDate } from '../../../utils/conversion';
import appointmentService from '../../../services/agendaApi/appointment.service';
import { debounce } from '@mui/material';

export interface IValuesSelector {
    value: number;
    label?: string;
    comparison?: string;
    subRetailID?: number;
}


export const columnsWidth: TableColumnWidth[] = [
    {
        columnId: "checkbox",
        width: '60px'
    },
    {
        columnId: "subRetail",
    },
    {
        columnId: "pointOfSale",
    },
    {
        columnId: "posOfCode",
    },
    {
        columnId: "stardDate",
    },
    {
        columnId: "endDate",
    }
];

export const initialColum2 = [
    {
        id: "checkbox",
        label: "",

    },
    {
        id: "subRetail",
        label: "subRetail",
    },
    {
        id: "pointOfSale",
        label: "pointOfSale",
    },
    {
        id: "posOfCode",
        label: "posOfCode",
    },
    {
        id: "stardDate",
        label: "stardDate",
        sortable: true,
    },
    {
        id: "endDate",
        label: "endDate",
    },
]
interface filterProps {
    valueActivation: number[],
    valueSubReatil: number[]
}

const initialFilters = {
    valueActivation: [],
    valueSubReatil: []

}

export default function ActivationAssignationLogic() {
    const [loadingTableData, setLoadingTableData] = useState<boolean>(false)
    const [columns2, setColumns2] = useState<TableColumns[]>(initialColum2);
    const [filters, setFilters] = useState<filterProps>(initialFilters)
    const [optionsActivation, setOptionsActivation] = useState<IValuesSelector[]>([]);
    const [optionsActivationCopy, setOptionsActivationCopy] = useState<IValuesSelector[]>([]);
    const [optionsSubReatilCopy, setOptionsSubReatilCopy] = useState<SelectOption[]>([]);
    const [optionsSubReatil, setOptionsSubReatil] = useState<SelectOption[]>([]);
    const [tableData, setTableData] = useState<TableData[]>([]);
    const [dataFiltered, setDataFiltered] = useState<TableData[]>([])
    const [currentPage, setCurrentPage] = useState(1);
    const [allSelected, setAllSelected] = useState(false);
    const [checkedStates, setCheckedStates] = useState<{ [key: string]: boolean }>({});
    const [editMassStartDate, setEditMassStartDate] = useState<Moment>();
    const [editMassEndDate, setEditMassEndDate] = useState<Moment>();
    const [singlestartDate, setSingleStartDate] = useState<Moment>();
    const [singleEndDate, setSingleEndDate] = useState<Moment>();
    const [itemSelected, setItemSelected] = useState<any>({});
    const [activationIdSelected, setActivationIdSelected] = useState<number>(0);
    const [openModal, setOpenModal] = useState(false);
    const [buttonToEdit, setButtonToEdit] = useState(false);
    const [openCreateActivation, setOpenCreateActivation] = useState(false);
    const [optionPosList, setOptionPosList] = useState<IValuesSelector[]>([]);
    const [optionPosListCopy, setOptionPosListCopy] = useState<IValuesSelector[]>([]);
    const [accordionData, setAccordionData] = useState<any[]>([]);
    const [messageSentActivation, setMessageSentActivation] = useState<string>('');
    const [openModalActivationSent, setOpenModalActivationSent] = useState(false)
    const [loadingSendInfo, setLoadingSendInfo] = useState(false)
    const [pageNumber, setPageNumber] = useState<number>(1)
    const [totalLength, setTotalLength] = useState<number>(0)

    const [t] = useTranslation("global");

    useEffect(() => {
        getActivations()
    }, [])

    useEffect(() => {
        if (dataFiltered.length > 0) {
            const data: TableData[] = mapDataToColumns(dataFiltered, initialColum2)
            setTableData(data)
        }
    }, [dataFiltered])

    useEffect(() => {
        if (tableData.length > 0) {
            const newData = initialColum2.map((item) => {
                if (item.id !== '' && item.id !== "checkbox") {
                    return {
                        ...item,
                        label: t(`header.${item.id}`),
                        filter: undefined
                    };
                }
                return item;
            });
            setColumns2(newData);
            mapDataToColumns(tableData, newData)
        } else {
            columns2.forEach((item) => {
                if (item.id !== '' && item.label !== "") {
                    item.label = t(`header.${item.id}`)
                }
            })
        }
    }, [t, tableData]);

    useEffect(() => {
        if (Object.keys(checkedStates).length === 1) {
            tableData.forEach((data) => {
                if (Object.keys(checkedStates).includes(data.activationAssignmentID.toString())) {
                    const start = moment(data?.stardDate).format('YYYY-MM-DD')
                    const end = moment(data?.endDate).format('YYYY-MM-DD')



                    setSingleStartDate(data?.stardDate);
                    setSingleEndDate(data?.endDate);
                    setItemSelected(data);

                    if (!start) {
                        console.log('Start date is invalid or empty:', start);
                        return;
                    }
                    if (!end) {
                        console.log('end date is invalid or empty:', end);
                        return;
                    }

                    const formattedStartDate = moment(start, 'YYYY-MM-DD', true);
                    const formattedEndDate = moment(end, 'YYYY-MM-DD', true);

                    if (!formattedStartDate.isValid()) {
                        console.log('Invalid start date:', start);
                        return;
                    }

                    if (!formattedEndDate.isValid()) {
                        console.log('Invalid end date:', end);
                        return;
                    }
                    setEditMassStartDate(formattedStartDate);
                    setEditMassEndDate(formattedEndDate);
                }
            });
        } else {
            setEditMassStartDate(undefined);
            setEditMassEndDate(undefined);
        }
    }, [checkedStates, tableData]);

    const createFilter = (
        label: string,
        handlerClear: () => void,
        handlerFilter: (value: string) => void
    ) => (
        <div style={{ width: '80%' }}>
            <Search
                label={label}
                placeholder={`Buscar ${label}`}
                id={`table-filter-${label.replace(/\s+/g, '')}`}
                onClear={handlerClear}
                onChange={(e) => handlerFilter(e!.toString())}
            />
        </div>
    );

    const handleSelectAll = useCallback(() => {
        const newAllSelected = !allSelected;
        setAllSelected(newAllSelected);

        const newCheckedStates: { [key: string]: boolean } = {};

        allSelected ? setCheckedStates(newCheckedStates) : tableData.forEach(item => { newCheckedStates[item.activationAssignmentID] = newAllSelected; });

        setTableData(prevData => prevData.map(item => ({
            ...item,
            checkbox: (
                <Checkbox
                    className="registerSalePriceCheckbox"
                    id={`checkbox-${item.posOfCode}`}
                    value={'checked'}
                    checked={newAllSelected}
                    onChange={() => handleCheckboxChange(item.activationAssignmentID)} // Recursión
                />
            )
        })));

        setCheckedStates(newCheckedStates);
    }, [allSelected, tableData]);

    const filterActivations = useCallback((query = '') => {

        if (query === '') {
            setOptionsActivation(optionsActivationCopy);
        } else {
            const filtered = optionsActivationCopy.filter(item => {
                return item.label && typeof item.label === 'string' && item.label.toLowerCase().includes(query.toLowerCase());
            });

            setOptionsActivation(filtered);
        }
    }, [optionsActivationCopy]);


    const handleCheckboxChange = useCallback((activationAssignmentID: string) => {
        setCheckedStates(prevState => {
            const newCheckedState = !prevState[activationAssignmentID];

            const newCheckedStates = { ...prevState };
            if (newCheckedState) {
                newCheckedStates[activationAssignmentID] = true;
            } else {
                delete newCheckedStates[activationAssignmentID];
            }

            setTableData(prevData => prevData.map(data => {
                if (Object.keys(newCheckedStates).length === prevData.length) {
                    setAllSelected(true);
                } else {
                    setAllSelected(false);
                }

                if (data.activationAssignmentID === activationAssignmentID) {
                    return {
                        ...data,
                        checkbox: (
                            <Checkbox
                                className="registerSalePriceCheckbox"
                                id={`checkbox-${data.activationAssignmentID}`}
                                value={'checked'}
                                checked={newCheckedState}
                                onChange={() => handleCheckboxChange(data.activationAssignmentID)}
                            />
                        )
                    };
                }
                return data;
            }));
            return newCheckedStates;
        });
    }, []);

    const getActivations = () => {
        setLoadingTableData(true);
        activationsService
            .getActivations()
            .then((result) => {
                const updatedOptions = result.map((item: any) => ({
                    value: item.activationID,
                    label: item.name,
                }));
                setOptionsActivation(updatedOptions);
                setOptionsActivationCopy(updatedOptions);
            })
            .finally(() => setLoadingTableData(false));
    };

    const getAssignmentOfActivation = (activityID: number, pageNumberID: number) => {
        setLoadingTableData(true);
        activationsService
            .getAssignmentOfActivation(activityID, pageNumberID)
            .then((result: IGetAssignmentOfActivationDto[]) => {
                setCheckedStates({});
                setDataFiltered((prevData) => [...prevData, ...result])
                if (result.length > 0) {
                    setTotalLength(result[0].totalLength!)
                }
            })
            .finally(() => setLoadingTableData(false));
    };

    const getDataSubretail = () => {
        appointmentService.getSubretailList().then((r: any) => {
            const mapData = r.map((subRetailID: { fieldID: number, fieldValue: string }) => {
                return {
                    value: subRetailID.fieldID,
                    label: subRetailID.fieldValue,
                }
            })
            setOptionsSubReatil(mapData)
            setOptionsSubReatilCopy(mapData)
        });
    };
    const handleFilterChange = debounce((field: keyof TableData, value: string) => {
        const lowerCaseValue = value.toLowerCase();

        const filterArray = dataFiltered.filter((element: TableData) => {
            const elementValue = element[field]?.toString().toLowerCase() || '';
            return elementValue.includes(lowerCaseValue);
        });

        const newData: TableData[] = mapDataToColumns(filterArray, initialColum2);
        setCurrentPage(1);
        setTableData(newData);
    }, 300);

    const mapDataToColumns = useCallback((dataArray: TableData[], columns: TableColumns[]): any[] => {
        const columnIdToFieldMap: { [key: string]: keyof TableData } = {
            "activationAssignmentID": "activationAssignmentID",
            "checkbox": "checkbox",
            "subRetail": "nameSubRetail",
            "pointOfSale": "pointOfSale",
            "posOfCode": "posCode",
            "stardDate": "startDate",
            "endDate": "endDate",
        };

        return dataArray.map(data => {
            const resultObject: { [key: string]: any } = {};
            resultObject['activationAssignmentID'] = data.activationAssignmentID;
            columns.forEach(column => {
                const field = columnIdToFieldMap[column.id];
                let value: string | number | React.ReactNode = "";

                if (field) {
                    if (column.id !== 'checkbox') {
                        if (column.id === 'stardDate' || column.id === 'endDate') {
                            value = moment(data[field]).format('DD-MM-YYYY')
                        } else {
                            value = data[field];
                        }
                    } else {
                        value = (
                            <Checkbox
                                className="registerSalePriceCheckbox"
                                id={`checkbox-${data.activationAssignmentID}`}
                                value={'checked'}
                                checked={checkedStates[data.activationAssignmentID] || false}
                                onChange={() => handleCheckboxChange(data.activationAssignmentID)}
                            />
                        );
                    }
                }
                if (column.filter === undefined && (!["checkbox", "stardDate", "endDate"].includes(column.id))) {
                    column.filter = createFilter(
                        column.label,
                        () => console.log('entra aqui'),
                        (value) => handleFilterChange(field, value)
                    );
                }

                resultObject[column.id] = value;
            });

            return resultObject;
        });
    }, [checkedStates]);

    const getPointOfsaleByList = (subRetailID: number[], type?: string) => {
        const values = subRetailID.join(',')
        appointmentService
            .getPosListBySubretailList(values)
            .then((result: any) => {
                if (type === '') {
                    mapCreateActivationBySubretail(subRetailID, result)
                } else {
                    const params: IValuesSelector[] = result.map((item: any) => {
                        return {
                            value: item.fieldID,
                            label: item.fieldValue,
                            subRetailID: Number(item.subretailID)
                        }
                    })

                    setOptionPosList(params)
                    setOptionPosListCopy(params)
                }
            })
            .catch(() => [])
    };

    const mapCreateActivationBySubretail = (subRetailID: number[], data: any[]) => {
        const newData = data.map((resp) => {
            const matchedElement = subRetailID.find(element => element.toString() === resp?.subretailID.toString());
            if (matchedElement) {
                return {
                    activationID: activationIdSelected,
                    subretailID: matchedElement.toString(),
                    details: [{
                        posCode: resp?.fieldID,
                        startDate: FormatDate(editMassStartDate, 'YYYY-MM-DD'),
                        endDate: FormatDate(editMassEndDate, 'YYYY-MM-DD')
                    }]
                };
            }
            return null;
        });

        createActivation(newData)
    }

    const mapCreateActivationByPos = () => {
        const newData = accordionData.map((resp) => {
            if (resp?.subRetailId) {
                return {
                    activationID: activationIdSelected,
                    subretailID: resp?.subRetailId.toString(),
                    details: [{
                        posCode: resp?.posCode,
                        startDate: FormatDate(resp?.startDate, 'YYYY-MM-DD'),
                        endDate: FormatDate(resp?.endDate, 'YYYY-MM-DD')
                    }]
                };
            }
            return null
        });

        createActivation(newData)
    }


    const handleEditMassStartDate = (date?: MomentObj | DateRange | undefined) => {
        if (!date || moment.isMoment(date)) {
            const newDate = date || undefined;

            if (editMassEndDate && newDate && newDate.isAfter(editMassEndDate)) {
                setEditMassStartDate(newDate);
                setEditMassEndDate(newDate);
            } else {
                setEditMassStartDate(newDate);
            }
        }
    };

    const handleEditMassEndDate = (date?: MomentObj | DateRange | undefined) => {
        if (!date || moment.isMoment(date)) {
            const newDate = date || undefined;
            if (editMassStartDate !== undefined && newDate !== undefined) {
                if (editMassStartDate > newDate) {
                    setEditMassEndDate(undefined);
                } else {
                    setEditMassEndDate(newDate);
                }
            }
        }
    };

    const isEndDateOutsideRangeEditMass = (day: MomentObj) => {
        return editMassStartDate ? day.isBefore(editMassStartDate, "day") : false;
    };

    const createActivation = (newData: any) => {
        setLoadingSendInfo(true)
        activationsService.createAssignmentOfActivation(newData).then((r) => {
            setOpenModalActivationSent(true)
            switch (r) {
                case 0: {
                    setMessageSentActivation(t("modal.generalError"))
                    break;
                }
                case 1: {
                    setMessageSentActivation(t("modal.assignationCreated"))
                    successfulpetition()
                    setOpenCreateActivation(false)
                    break;
                }
                default: {
                    setOpenCreateActivation(false)
                }
            }
        }).finally(() => {
            setOpenModalActivationSent(true)
            setLoadingSendInfo(false)
        });
    }

    const handleUpdateAssingation = () => {
        setLoadingSendInfo(true)
        if (editMassStartDate !== undefined && editMassEndDate !== undefined) {
            activationsService
                .updateAssignmentOfActivationInBulk(
                    Object.keys(checkedStates).join(", "),
                    FormatDate(editMassStartDate, 'YYYY-MM-DD'),
                    FormatDate(editMassEndDate, 'YYYY-MM-DD')
                )
                .then((r) => {

                    switch (r) {
                        case 0:
                            setMessageSentActivation(t("modal.generalError"))
                            break
                        case 1: {
                            setMessageSentActivation(t("modal.updateInfo"))
                            successfulpetition()
                        }
                    }
                }).finally(() => {
                    setOpenModalActivationSent(true)
                    setLoadingSendInfo(false)
                }
                );
        }
    }

    const handleDeleteAssingation = () => {
        setLoadingSendInfo(true)
        activationsService
            .deleteAssignmentOfActivationInBulk(Object.keys(checkedStates).join(", "))
            .then((r) => {
                switch (r) {
                    case 0: {
                        setMessageSentActivation(t("modal.generalError"))
                        break;
                    }
                    case 1: {
                        setMessageSentActivation(t("modal.deleteAssingation"))
                        successfulpetition()
                        break;
                    }
                }
            }).finally(() => {
                setOpenModalActivationSent(true)
                setLoadingSendInfo(false)
            });
    }


    const successfulpetition = () => {
        setCurrentPage(1)
        setPageNumber(1)
        setTableData([])
        setDataFiltered([])
        handleCloseModal()
        setAllSelected(false)
        getAssignmentOfActivation(activationIdSelected, 1)
    }

    const handleCloseModal = () => {
        if (Object.keys(checkedStates).length !== 1) {
            setEditMassStartDate(undefined);
            setEditMassEndDate(undefined);
        }
        setOpenModal(false);
        setButtonToEdit(false)
    };

    const handleOpenEditModal = () => {
        setOpenModal(true);
        setButtonToEdit(true);
    };

    return {
        filters, setFilters, tableData, getAssignmentOfActivation, setActivationIdSelected,
        columns2, columnsWidth, loadingTableData, optionsActivation, openModal, setOpenModal,
        currentPage, setCurrentPage, handleSelectAll, allSelected, checkedStates, optionsSubReatil,
        handleEditMassStartDate, handleEditMassEndDate, editMassStartDate, editMassEndDate,
        isEndDateOutsideRangeEditMass, handleUpdateAssingation, handleDeleteAssingation,
        buttonToEdit, setButtonToEdit, handleCloseModal, handleOpenEditModal, itemSelected,
        getDataSubretail, setOptionsSubReatil, optionsSubReatilCopy, getPointOfsaleByList, setOptionPosList,
        openCreateActivation, setOpenCreateActivation, optionPosList, optionPosListCopy, activationIdSelected,
        accordionData, setAccordionData, mapCreateActivationByPos, setOpenModalActivationSent, openModalActivationSent,
        messageSentActivation, singlestartDate, singleEndDate, filterActivations, loadingSendInfo, setTableData, setPageNumber,
        totalLength, pageNumber, setDataFiltered
    }
}